import React from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {w100} from "@pg-design/helpers-css";
import {NAVIGATION_TEST_IDS} from "@pg-mono/test-ids";

interface IProps {
    handleClear: () => void;
    handleSave: (e: React.MouseEvent<HTMLElement>) => void;
    submitText?: string;
    clearText?: string;
}

export const SortFilterFooter: React.FunctionComponent<IProps> = ({handleSave, handleClear, submitText = "Wybierz", clearText = "Wyczyść"}) => {
    return (
        <div css={filterFooter}>
            <Button variant="filled_primary" onClick={handleSave} size="small" css={fullWidthButton} dataTestId={NAVIGATION_TEST_IDS.SORT_SELECT_BUTTON}>
                {submitText}
            </Button>

            <Button variant="none_secondary" onClick={handleClear} size="small" css={w100}>
                {clearText}
            </Button>
        </div>
    );
};

const filterFooter = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`;

const fullWidthButton = css`
    width: 100%;
`;
import React from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {w100} from "@pg-design/helpers-css";
import {NAVIGATION_TEST_IDS} from "@pg-mono/test-ids";

interface IProps {
    handleClear: () => void;
    handleSave: (e: React.MouseEvent<HTMLElement>) => void;
    submitText?: string;
    clearText?: string;
}

export const SortFilterFooter: React.FunctionComponent<IProps> = ({handleSave, handleClear, submitText = "Wybierz", clearText = "Wyczyść"}) => {
    return (
        <div css={filterFooter}>
            <Button variant="filled_primary" onClick={handleSave} size="small" css={fullWidthButton} dataTestId={NAVIGATION_TEST_IDS.SORT_SELECT_BUTTON}>
                {submitText}
            </Button>

            <Button variant="none_secondary" onClick={handleClear} size="small" css={w100}>
                {clearText}
            </Button>
        </div>
    );
};

const filterFooter = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`;

const fullWidthButton = css`
    width: 100%;
`;
